import {
  REPORT_CASHIER_PATH,
  REPORT_FINANCIAL_PATH,
  REPORT_FRONTDESK_PATH,
  REPORT_RESERVATION_PATH,
} from '@constants/Navigation/AppPaths/ReportPaths';
import { Box, Drawer, Stack, Typography } from '@mui/material';
import { RootContextProps } from 'components/RootContainer';
import { Crumb } from 'components/TranslatableCrub';
import React, { FC } from 'react';
import { Outlet, RouteObject, useRouteError } from 'react-router-dom';
import EmptyContent from '../../../components/EmptyContent';
import { Bookmark2Icon } from '../../../components/SvgIcons/Bookmark2Icon';
import { ReportMenu } from '../components/ReportMenu';
import { reportCashierRoutePaths } from '../pages/ReportCashierModule/routing/routes';
import { reportFinancialRoutePaths } from '../pages/ReportFinancialModule/routing/routes';
import { reportFrontdeskRoutePaths } from '../pages/ReportFrontdeskModule/routing/routes';
import { reportReservationRoutePaths } from '../pages/ReportRservationModule/routing/routes';

const LandingPage: FC = (): JSX.Element => {
  return (
    <Stack position="relative" width="100%" height="100%" direction="row">
      <Drawer
        open={true}
        sx={{
          flexShrink: 0,
          height: '100%',
          zIndex: 0,
          '& .MuiDrawer-paper': {
            position: 'sticky',
            width: '24rem',
            boxSizing: 'border-box',
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            border: 'none',
            backgroundColor: 'colors.gray.o10',
          },
        }}
        variant="persistent"
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <Typography
            sx={{
              position: 'sticky',
              top: 0,
              padding: '2rem 1rem 1.5rem 1.5rem',
              zIndex: 1,
              // left: -5,
              ml: -1,
            }}
            variant="inter20"
            width={'100%'}
            color="colors.blueR.o90"
            fontWeight={theme => theme.typography.fontWeightBold}
          >
            Reports categories
          </Typography>
          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
            <ReportMenu />
          </Box>
        </Box>
      </Drawer>
      <Stack position="relative" width="100%" height="100%">
        <EmptyContent IconProps={<Bookmark2Icon />} title="Reports" subTitle="Generate report" />
      </Stack>
    </Stack>
  );
};

const ReportBoundary: FC = (): JSX.Element => {
  let error = useRouteError() as Error;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        height: '100%',
      }}
    >
      <h2>Error : </h2>
      <p>{error.message}</p>
    </Box>
  );
};

export const reportRoutePaths = (api: RootContextProps): RouteObject[] => [
  {
    index: true,
    element: <LandingPage />,
    errorElement: <ReportBoundary />,
  },
  {
    path: `${REPORT_RESERVATION_PATH}`,
    element: (
      <React.Suspense fallback={<>...</>}>
        <Outlet />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="report.menu.reservation" path={null} />,
    },
    children: reportReservationRoutePaths(api),
  },
  {
    path: `${REPORT_FRONTDESK_PATH}`,
    element: (
      <React.Suspense fallback={<>...</>}>
        <Outlet />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="report.menu.frontdesk" path={null} />,
    },
    children: reportFrontdeskRoutePaths(api),
  },
  {
    path: `${REPORT_CASHIER_PATH}`,
    element: (
      <React.Suspense fallback={<>...</>}>
        <Outlet />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="report.menu.cashier" path={null} />,
    },
    children: reportCashierRoutePaths(api),
  },
  {
    path: `${REPORT_FINANCIAL_PATH}`,
    element: (
      <React.Suspense fallback={<>...</>}>
        <Outlet />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="report.menu.financial" path={null} />,
    },
    children: reportFinancialRoutePaths(api),
  },
];
